exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error[data-v-382a3ba7]{background-color:transparent!important;color:#ff5252;display:block}#days-subgroups .v-input--selection-controls[data-v-382a3ba7]{margin-top:0!important}", ""]);

// exports
